export const cytoscapeStyles = [
  {
    selector: 'node',
    style: {
      shape: 'round-rectangle',
      label: 'data(label)',
      'font-size': '15px',
      'font-family': 'Open Sans',
      'font-weight': '400',
      'text-wrap': 'wrap',
      'text-valign': 'center',
      'text-halign': 'center',
      padding: '5px 7px 5px 7px',
      'text-max-width': '120px',
      width: (ele) => `${Math.min(ele.data('label').length * 9, 120)}px`,
      height: (ele) => {
        const maxWidth = 120;
        const label = ele.data('label');
        const lines = Math.ceil(label.length * 10 / maxWidth); // Estimar número de líneas
        return `${lines * 15 + 8}px`; // Altura base + padding
      },
    },
  },
  {
    selector: '$node > node',
    style: {
      shape: 'round-rectangle',
      'background-color': '#E6E6E9',
      'text-valign': 'bottom', 
      'text-margin-y': 8,
    },
  },
  {
    selector: 'edge',
    style: {
      'line-color': '#000',
      width: 1,
      'target-arrow-shape': 'triangle',
    },
  },
  {
    selector: '.sistema',
    style: {
      'background-color': '#00748C',
      'border-color': 'black',
      'color': 'white',
      'border-width': 1,  
    },
  },
  {
    selector: '.org',
    style: {
      'background-color': '#f7f7f7',
      'border-color': 'black',
      'border-width': 1,
    },
  },
  {
    selector: '.nivel1',
    style: {
      'background-color': '#E6E6E9',
      'border-color': 'black',
      'border-width': 1,
    },
  },
  {
    selector: '.nivel2',
    style: {
      label: 'data(label)',
      'text-valign': 'center',
      'text-halign': 'center',
      'background-color': '#CACACE',
      'text-wrap': 'wrap',
      'text-margin-y': 2,
      'text-background-opacity': 0,
      'border-width': 1
    }
  },
  {
    selector: '.manual',
    style: {
      'line-style': 'dashed',
      'target-arrow-shape': 'triangle',
    },
  },
  {
    selector: 'node.dimmed',
    style: {
      opacity: 0.2,
    },
  },
  {
    selector: 'edge.dimmed',
    style: {
      opacity: 0.2,
    },
  },
  {
    selector: '.hidden',
    style: {
      display: 'none',
    },
  },
];

